<template>
  <BaseButton
    :aria-label="title"
    :title="title"
    @click.native="$event => $emit('click', $event)"
    v-bind="$attrs"
    data-test="icon-button"
    class="l-IconButton">
    <FontIcon
      data-test="icon"
      :class="{ 'mr-sm': hasSlotContent }"
      :name="icon"
    />
    <slot />
  </BaseButton>
</template>

<script>
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import FontIcon from '@/components/Icon.vue';

export default {
  name: 'IconButton',
  components: {
    BaseButton,
    FontIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
  },
  computed: {
    hasSlotContent() {
      return !!this.$slots.default;
    },
    title() {
      return !this.hasSlotContent ? this.label : null;
    },
  },
};
</script>
